// SistemaMaster.js
import React, { useState, useEffect } from "react";
import { Container, Nav, Tab, Navbar, Spinner, Collapse } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import api from "../../services/api";

import {
  People,
  PersonBadge,
  Tools,
  CalendarCheck,
  Gear,
  BoxArrowRight,
  BoxSeam,
  Speedometer
} from "react-bootstrap-icons";

import { useColors } from "../../contexts/ColorContext";
import GerenciarClientes from "./master/GerenciarClientes";
import GerenciarFuncionarios from "./master/GerenciarFuncionarios";
import GerenciarServicos from "./master/GerenciarServicos";
import ConsultarAgendamentosMaster from "./master/ConsultarAgendamentosMaster";
import DashboardMaster from "./master/DashboardMaster";
import ControleEstoqueMaster from "./master/ControleEstoqueMaster";
import ConfiguracoesApi from "./master/ConfiguracoesApi";
import ConfiguracaoCores from "./master/ConfiguracaoCores";
import ConfiguracaoMenuia from "./master/ConfiguracaoMenuia";

function SistemaMaster() {
  const navigate = useNavigate();
  const { colors } = useColors();
  const { primaryColor, secondaryColor, bgColor, textColor, sidebarColor, btnTextColor } = colors;

  const [activeKey, setActiveKey] = useState("dashboard");
  const [openConfig, setOpenConfig] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const [clienteMaster, setClienteMaster] = useState(null);
  const [loading, setLoading] = useState(true);
const [expanded, setExpanded] = useState(false);

  // Fetch usuário + clienteMaster
  useEffect(() => {
    const storedUser = Cookies.get("usuario");
    if (!storedUser) { navigate("/login"); return; }
    const user = JSON.parse(storedUser);
    setUsuario(user);

    const fetchMaster = async () => {
      try {
        let res;
        const celularLimpo = user.celular?.replace(/\D/g, "");
        if (user.role === "Funcionario" && celularLimpo) {
          res = await api.get(`/ClienteMaster/by-celular/${celularLimpo}`);
        } else {
          res = await api.get(`/ClienteMaster/${user.id}`);
        }
        setClienteMaster(res.data);
      } catch (err) {
        console.error("Erro ao buscar ClienteMaster:", err);
      } finally { setLoading(false); }
    };
    fetchMaster();
  }, [navigate]);

  const handleLogout = () => {
    Cookies.remove("usuario");
    navigate("/login");
  };

  if (loading) {
    return (
      <div style={{ background: bgColor, color: textColor, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spinner animation="border" />
      </div>
    );
  }

  const sidebarStyle = {
    backgroundColor: sidebarColor,
    color: textColor,
    minHeight: "100vh",
    paddingTop: "20px"
  };

  const navLinkStyle = {
    color: textColor,
    padding: "10px 15px",
    borderRadius: "8px",
    margin: "5px 0",
    display: "flex",
    alignItems: "center",
    cursor: "pointer"
  };

  const navLinkActiveStyle = {
    backgroundColor: primaryColor,
    color: btnTextColor || "#fff",
    fontWeight: "bold",
    border: `1px solid ${primaryColor}`,
    display: "flex",
    alignItems: "center",
    padding: "10px 15px",
    borderRadius: "8px",
    margin: "5px 0",
    cursor: "pointer"
  };

  const contentStyle = { backgroundColor: bgColor, minHeight: "100vh", padding: "30px", color: textColor };

  // Sidebar items
  const sidebarItems = [
    { key: "dashboard", label: "Dashboard", icon: Speedometer },
    { key: "clientes", label: "Gerenciar Clientes", icon: People },
    { key: "funcionarios", label: "Gerenciar Funcionários", icon: PersonBadge },
    { key: "servicos", label: "Gerenciar Serviços", icon: Tools },
    { key: "estoque", label: "Controle de Estoque", icon: BoxSeam },
    { key: "agendamentos", label: "Controle de Agenda", icon: CalendarCheck }

  ];

  const configSubItems = [
    { key: "configuracoesApi", label: "Gerais" },
    { key: "configuracaoCores", label: "Cores" },
    { key: "configuracaoMenuia", label: "WhatsApp" }
  ];

  return (
    <div className="d-flex" style={{ minHeight: "100vh" }}>
      {/* Sidebar */}
      <div style={sidebarStyle} className="col-lg-2 col-md-3 d-none d-md-block">
        <h4 className="text-center mb-4" style={{ color: primaryColor }}>Administrador</h4>
        <p className="text-center text-muted small">Bem-vindo, {usuario?.nome}!</p>

        <Nav className="flex-column px-3">
  {sidebarItems.map(item => {
    const Icon = item.icon;
    const isActive = activeKey === item.key;
    return (
      <Nav.Item key={item.key}>
        <div
          onClick={() => setActiveKey(item.key)}
          style={isActive ? navLinkActiveStyle : navLinkStyle}
        >
          <Icon className="me-2" size={18} color={isActive ? btnTextColor : textColor} />
          {item.label}
        </div>
      </Nav.Item>
    );
  })}

  <Nav.Item>
    <div
      onClick={() => setOpenConfig(!openConfig)}
      style={openConfig ? navLinkActiveStyle : navLinkStyle}
    >
      <Gear
        className="me-2"
        size={18}
        color={openConfig ? btnTextColor : textColor}
      />
      Configurações
    </div>

    <Collapse in={openConfig}>
      <div className="ms-3 mt-1">
        {configSubItems.map(sub => (
          <Nav.Item key={sub.key}>
            <div
              onClick={() => setActiveKey(sub.key)}
              style={activeKey === sub.key ? navLinkActiveStyle : navLinkStyle}
            >
              {sub.label}
            </div>
          </Nav.Item>
        ))}
      </div>
    </Collapse>
  </Nav.Item>

  <Nav.Item className="mt-4">
    <div
      onClick={handleLogout}
      style={{ ...navLinkStyle, color: "#dc3545", cursor: "pointer" }}
    >
      <BoxArrowRight className="me-2" size={18} /> Sair
    </div>
  </Nav.Item>
</Nav>
      </div>

      {/* Conteúdo */}
      <div className="col-lg-10 col-md-9 col-12" style={contentStyle}>
        <Navbar
  expand="md"
  variant="dark"
  expanded={expanded}
  onToggle={(val) => setExpanded(val)}
  style={{ backgroundColor: secondaryColor }}
  className="d-md-none mb-3 rounded"
>
  <Container fluid>
    <Navbar.Brand style={{ color: primaryColor }}>Administrador</Navbar.Brand>

    <Navbar.Toggle aria-controls="basic-navbar-nav" />

     <Navbar.Collapse id="mobile-navbar">
  <Nav className="me-auto">

    {/* Dashboard */}
    <Nav.Link
      onClick={() => { setActiveKey("dashboard"); setExpanded(false); }}
      className="d-flex align-items-center"
    >
      <Speedometer size={18} className="me-2" />
      Dashboard
    </Nav.Link>

    {/* Clientes */}
    <Nav.Link
      onClick={() => { setActiveKey("clientes"); setExpanded(false); }}
      className="d-flex align-items-center"
    >
      <People size={18} className="me-2" />
      Gerenciar Clientes
    </Nav.Link>

    {/* Funcionários */}
    <Nav.Link
      onClick={() => { setActiveKey("funcionarios"); setExpanded(false); }}
      className="d-flex align-items-center"
    >
      <PersonBadge size={18} className="me-2" />
      Gerenciar Funcionários
    </Nav.Link>

    {/* Serviços */}
    <Nav.Link
      onClick={() => { setActiveKey("servicos"); setExpanded(false); }}
      className="d-flex align-items-center"
    >
      <Tools size={18} className="me-2" />
      Gerenciar Serviços
    </Nav.Link>

    {/* Estoque */}
    <Nav.Link
      onClick={() => { setActiveKey("estoque"); setExpanded(false); }}
      className="d-flex align-items-center"
    >
      <BoxSeam size={18} className="me-2" />
      Controle de Estoque
    </Nav.Link>

    {/* Agendamentos */}
    <Nav.Link
      onClick={() => { setActiveKey("agendamentos"); setExpanded(false); }}
      className="d-flex align-items-center"
    >
      <CalendarCheck size={18} className="me-2" />
      Controle de Agenda
    </Nav.Link>

    {/* Configurações - Gerais */}
    <Nav.Link
      onClick={() => { 
        setOpenConfig(true);
        setActiveKey("configuracoesApi"); 
        setExpanded(false);
      }}
      className="d-flex align-items-center"
    >
      <Gear size={18} className="me-2" />
      Configurações – Gerais
    </Nav.Link>

    {/* Configurações - Cores */}
    <Nav.Link
      onClick={() => { 
        setOpenConfig(true);
        setActiveKey("configuracaoCores"); 
        setExpanded(false);
      }}
      className="d-flex align-items-center"
    >
      <Gear size={18} className="me-2" />
      Configurações – Cores
    </Nav.Link>

    {/* Configurações - API Menuia */}
    <Nav.Link
      onClick={() => { 
        setOpenConfig(true);
        setActiveKey("configuracaoMenuia"); 
        setExpanded(false);
      }}
      className="d-flex align-items-center"
    >
      <Gear size={18} className="me-2" />
      Configurações – API Menuia
    </Nav.Link>

    {/* Sair */}
    <Nav.Link
      onClick={() => { handleLogout(); setExpanded(false); }}
      className="d-flex align-items-center"
      style={{ color: "#dc3545" }}
    >
      <BoxArrowRight size={18} className="me-2" />
      Sair
    </Nav.Link>

  </Nav>
</Navbar.Collapse>

  </Container>
</Navbar>

        <Tab.Container activeKey={activeKey}>
          <Tab.Content>
            <Tab.Pane eventKey="dashboard"><DashboardMaster idClienteMaster={clienteMaster?.id} /></Tab.Pane>
            <Tab.Pane eventKey="clientes"><GerenciarClientes /></Tab.Pane>
            <Tab.Pane eventKey="funcionarios"><GerenciarFuncionarios /></Tab.Pane>
            <Tab.Pane eventKey="servicos"><GerenciarServicos /></Tab.Pane>
            <Tab.Pane eventKey="estoque"><ControleEstoqueMaster /></Tab.Pane>
            <Tab.Pane eventKey="agendamentos"><ConsultarAgendamentosMaster /></Tab.Pane>
            <Tab.Pane eventKey="configuracoesApi"><ConfiguracoesApi /></Tab.Pane>
            <Tab.Pane eventKey="configuracaoCores"><ConfiguracaoCores idClienteMaster={clienteMaster?.id} /></Tab.Pane>
            <Tab.Pane eventKey="configuracaoMenuia"><ConfiguracaoMenuia /></Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
}

export default SistemaMaster;
